"use client";

import {
    Grid,
    Tab,
    TabList,
    TabGroup,
    TabPanel,
    TabPanels
} from "@tremor/react";
import { useSelector } from 'react-redux';
import { Skeleton } from "@mui/material";
import { CheckingCountKPI, CheckingPerHourKPI, CheckingValueKPI, CumulativeCheckingByProductKPI, CumulativeCheckingByUserKPI } from "./helper";
import ComparativeCardKpi from "../component/comparativeCardKpi";
import KpiAreaChart from "../component/areaChart";
import ListProgressBarAccordion from "../component/listProgressBarAccordion";
import ListChecking from "./list";
import { isLoading } from "../component/loading/store";
import useTrademarkFilter from "../../hooks/useTrademarkFilter";

export default function Checking() {
    const kpiChecking = useSelector((state) => state.kpiChecking)
    const loadingChecking = useSelector((state) => isLoading(state, 'KPI_CHECKING'))

    // faz o filtro das listas de checkings por marca selecionada pelo usuário
    const filteredKpiChecking = useTrademarkFilter(kpiChecking)

    const cardCheckingCountKPI = CheckingCountKPI(filteredKpiChecking)
    const cardCheckingValueKPI = CheckingValueKPI(filteredKpiChecking)

    const chartCheckingPerHourKPI = CheckingPerHourKPI(filteredKpiChecking)

    const cardCumulativeCheckingByUserKPI = CumulativeCheckingByUserKPI(filteredKpiChecking)
    const cardCumulativeCheckingByProductKPI = CumulativeCheckingByProductKPI(filteredKpiChecking)

    return (
        <TabGroup className="mt-0">
            <TabList>
                <Tab>Visão geral</Tab>
                <Tab>Listagem</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <Grid numItemsSm={1} numItemsMd={2} numItemsLg={2} className="gap-6 mt-6">
                        {!loadingChecking ? (
                            <>
                                <ComparativeCardKpi {...cardCheckingCountKPI} />
                                <ComparativeCardKpi {...cardCheckingValueKPI} />
                            </>
                        ) : (
                            <>
                                <Skeleton variant="rounded" height={150} />
                                <Skeleton variant="rounded" height={150} />
                            </>
                        )}
                    </Grid>

                    <div className="mt-6">
                        <Grid numItemsSm={1} numItemsMd={1} numItemsLg={1} className="gap-6 mt-6">
                            {!loadingChecking ? (
                                <KpiAreaChart {...chartCheckingPerHourKPI} />
                            ) : (
                                <Skeleton variant="rounded" height={300} />
                            )}
                        </Grid>
                    </div>

                    <div className="mt-6">
                        <Grid numItemsSm={1} numItemsMd={1} numItemsLg={1} className="gap-6 mt-6">
                            {!loadingChecking ? (
                                <>
                                    <ListProgressBarAccordion {...cardCumulativeCheckingByUserKPI} />
                                    <ListProgressBarAccordion {...cardCumulativeCheckingByProductKPI} />
                                </>
                            ) : (
                                <>
                                    <Skeleton variant="rounded" height={300} />
                                    <Skeleton variant="rounded" height={300} />
                                </>
                            )}
                        </Grid>
                    </div>
                </TabPanel>
                <TabPanel>
                    <ListChecking data={filteredKpiChecking.listAllChecking || []} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    );
}